export default __webpack_public_path__ + "static/media/gammeZephir.4fb1f9c8.png";